import { useAsyncData, useNuxtApp } from '#imports'

import { useBuybackOffer } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/composables/useBuybackOffer/useBuybackOffer'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

/**
 * Client-only fetch of the trade-in pickers (PPI-7770), the direct successor of the
 * pre-PPI-7740 combined `services/pickers` client call, now scoped to trade-in only
 * (mobile-plan data is fetched server-side by `useFetchMobilePlanPickers`).
 *
 * Trade-in reflects the user's cart/session, so this can't be cached or fetched SSR.
 */
export function useFetchTradeInPickers() {
  const nuxtApp = useNuxtApp()

  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()
  const { buybackOffer } = useBuybackOffer()

  return useAsyncData(
    () =>
      getAsyncDataKey('pp-trade-in-pickers', {
        productId,
        buybackOffer: buybackOffer.value?.listing.listingPublicId,
      }),
    async () =>
      $httpFetch(
        '/product-page/products/:productId/services/trade-in-pickers',
        {
          pathParams: { productId },
        },
      ),
    {
      // Trade-in reflects the user's session (checks the user's cart), so it's only
      // called client-side — we can't cache or SSR its response.
      server: false,
      lazy: true,
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
